import { createImage } from '@liveauctioneers/hammer-ui-core/card/components/createImage';
import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';
import { createName } from '@liveauctioneers/hammer-ui-core/card/components/createName';
import { cardFactory } from '@liveauctioneers/hammer-ui-core/card/factory';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';

import { ArticleSummary } from '@/redux/modules/article/article.types';
import { formatArticleDate } from '@/utils/dates';
import { getGuideArticleUrl } from '@/utils/urls';

import { ArticleLinkCardImage } from './components/ArticleLinkCardImage';

const getGuideHref = ({ slug, topic }: ArticleSummary) => getGuideArticleUrl(topic, slug);

export const ARTICLE_LINK_CARD_WIDTH_CLASS = 'w-[240px] smMin:w-[381px]';

export const ArticleLinkCard = cardFactory<ArticleSummary>({
    components: [
        createImage<ArticleSummary>({
            aspectRatio: 2,
            ImageComponent: ArticleLinkCardImage,
            useHref: getGuideHref,
        }),
        { spacerPx: 8 },
        createName<ArticleSummary>({
            className: 'line-clamp-2 text-text-primary font-semibold',
            useHref: getGuideHref,
            useText: ({ title }) => title,
        }),
        { spacerPx: 4 },
        createInfo<ArticleSummary>({
            className: 'line-clamp-0',
            useText: ({ author, createdAt }) => {
                const formattedDate = formatArticleDate(createdAt);

                if (!author && !formattedDate) {
                    return null;
                }

                return (
                    <div className="flex flex-col gap-2xs">
                        {author && <BodySecondary color="secondary">By {author}</BodySecondary>}
                        {formattedDate && <BodySecondary color="secondary">{formattedDate}</BodySecondary>}
                    </div>
                );
            },
        }),
    ],
    name: 'ArticleLinkCard',
});
